export const FETCH_ALL_CACHE = "__fac__";
